import * as React from 'react';
import { Link } from 'react-router-dom';
import { TopTaken } from './TopTaken';
import { MijnFnvTopTaken } from '../pages/interfaces/PageInterfaces';

export const MijnFNVHero = (props: MijnFnvTopTaken) => {
  if (props.MijnFnvTopTaken.length == 0) {
    return <></>;
  }
  
  return <div className="mijn-fnv__hero-container-outer mijn-fnv__widget">
    <div className="container hero__container mijn-fnv__hero-container hero__toptaken-inner-container">
      <span className="h1">{props.TaskIntroText}</span>
      {TopTaken(props)}
    </div>
  </div>;
  };
